<template lang="html">
  <div v-bind:id="id">
    <component v-bind:is="compMetadata.type" v-bind:id="compMetadata.id" v-bind:config="compMetadata.config"></component>
  </div>
</template>

<script>

export default {
  name: 'bulmaWizardContainer',
  components: { },
  computed: {
    compMetadata: function() {
      return this.$store.getters.getObject(this.id).data;
    }
  },
  
  props: {
      id: String,
   },
  
  data() {
    return {

    }
  },
  
  created: async function() { },
  
  mounted: function() { },
  
  methods: { }
}
</script>

<style scoped>


</style>
